(() => {
  if (window.roxariEngravingReady) return;
  window.roxariEngravingReady = true;
  const feeId = 67802963149114;
  const root = window.Shopify?.routes?.root || '/';
  const segments = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
  const count = text => [...segments.segment(text.normalize('NFC'))].filter(part => !/^\s+$/u.test(part.segment)).length;
  const request = async (path, body) => {
    const response = await fetch(root + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update engraving. Please try again.');
    return data;
  };
  const reconcile = async () => {
    const cart = await request('cart.js');
    const updates = {};
    const missing = [];
    for (const item of cart.items.filter(item => item.variant_id !== feeId)) {
      const characters = count(item.properties?.Engraving || '');
      if (!characters) continue;
      const child = cart.items.find(line => line.variant_id === feeId && line.parent_relationship?.parent_key === item.key);
      const quantity = characters * item.quantity;
      if (child && child.quantity !== quantity) updates[child.key] = quantity;
      if (!child) missing.push({ id: feeId, quantity, parent_line_key: item.key, properties: { Engraving: item.properties.Engraving } });
    }
    if (Object.keys(updates).length) await request('cart/update.js', { updates });
    if (missing.length) await request('cart/add.js', { items: missing });
  };
  const init = () => {
    document.querySelectorAll('[data-rx-engraving]').forEach(section => {
      if (section.dataset.paidReady) return;
      const input = section.querySelector('input[name="properties[Engraving]"]');
      const form = input?.form;
      if (!form) return;
      section.dataset.paidReady = 'true';
      input.removeAttribute('maxlength');
      const help = section.querySelector('p');
      const status = document.createElement('p');
      status.setAttribute('role', 'status');
      section.querySelector('.rx-accordion__body').append(status);
      const nativePayment = form.querySelector('.shopify-payment-button');
      const buy = document.createElement('button');
      buy.type = 'button';
      buy.className = 'btn btn--full';
      buy.textContent = 'Buy it now';
      buy.hidden = true;
      buy.style.setProperty('display', 'none', 'important');
      if (nativePayment) nativePayment.after(buy);
      let busy = false;
      const sync = () => {
        const characters = count(input.value);
        help.textContent = 'Engraving: Rs 100 per letter, number or symbol. Spaces are free.';
        status.textContent = characters ? 'Engraving total: Rs ' + (characters * 100).toLocaleString('en-PK') : '';
        if (nativePayment) nativePayment.hidden = characters > 0;
        buy.hidden = !characters;
        buy.style.setProperty('display', characters ? 'block' : 'none', 'important');
        if (nativePayment) nativePayment.style.setProperty('display', characters ? 'none' : '', 'important');
      };
      const add = async checkout => {
        if (busy) return;
        busy = true;
        buy.disabled = true;
        const button = form.querySelector('[data-add-to-cart]');
        if (button) button.disabled = true;
        try {
          const data = new FormData(form);
          const id = Number(data.get('id'));
          const quantity = Number(data.get('quantity') || 1);
          const properties = {};
          for (const [name, value] of data) {
            const match = name.match(/^properties\[(.*)\]$/);
            if (match && typeof value === 'string' && value) properties[match[1]] = value;
          }
          const characters = count(input.value);
          properties.Engraving = input.value;
          const parent = { id, quantity, properties };
          if (data.get('selling_plan')) parent.selling_plan = data.get('selling_plan');
          await request('cart/add.js', { items: [parent, { id: feeId, quantity: characters * quantity, parent_id: id, properties: { Engraving: input.value } }] });
          if (checkout) await reconcile();
          window.location.assign(root + (checkout ? 'checkout' : 'cart'));
        } catch (error) {
          status.textContent = error.message;
          busy = false;
          buy.disabled = false;
          if (button) button.disabled = false;
        }
      };
      form.addEventListener('submit', event => {
        if (!count(input.value)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        add(false);
      }, true);
      buy.addEventListener('click', () => { if (form.reportValidity()) add(true); });
      section.querySelectorAll('[data-rx-engraving-symbol]').forEach(symbolButton => {
        symbolButton.addEventListener('click', () => {
          const symbol = symbolButton.dataset.rxEngravingSymbol;
          const start = input.selectionStart ?? input.value.length;
          const end = input.selectionEnd ?? input.value.length;
          input.setRangeText(symbol, start, end, 'end');
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus({ preventScroll: true });
        });
      });
      input.addEventListener('input', () => { const cleaned = input.value.replace(/[^A-Za-z0-9 ∞♡☾&]/g, ''); if (input.value !== cleaned) input.value = cleaned; sync(); });
      sync();
    });
  };
  let checkoutBusy = false;
  let cartBusy = false;
  const changeQuantity = async (row, quantity) => {
    if (cartBusy) return;
    cartBusy = true;
    try {
      await request('cart/change.js', { id: row.dataset.key, quantity: Math.max(0, quantity) });
      await reconcile();
      window.location.reload();
    } catch (error) {
      cartBusy = false;
      alert(error.message);
    }
  };
  const checkout = async event => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutBusy || cartBusy) return;
    checkoutBusy = true;
    try {
      await reconcile();
      window.location.assign(root + 'checkout');
    } catch (error) {
      checkoutBusy = false;
      alert(error.message);
    }
  };
  document.addEventListener('click', event => {
    const row = event.target.closest('[data-rx-engraved-cart]');
    const adjust = event.target.closest('.js-qty__adjust');
    const remove = event.target.closest('.cart__remove a');
    if (row && (adjust || remove)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const current = Number(row.querySelector('[name="updates[]"]').value);
      changeQuantity(row, remove ? 0 : current + (adjust.classList.contains('js-qty__adjust--plus') ? 1 : -1));
      return;
    }
    if (event.target.closest('[name="checkout"], a[href="/checkout"], a[href="' + root + 'checkout"]')) checkout(event);
  }, true);
  document.addEventListener('change', event => {
    const row = event.target.closest('[data-rx-engraved-cart]');
    if (!row || !event.target.matches('[name="updates[]"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const quantity = Number(event.target.value);
    if (Number.isInteger(quantity)) changeQuantity(row, quantity);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') checkout(event);
  }, true);
  init();
  document.addEventListener('shopify:section:load', init);
  let frame;
  // Only rescan when newly inserted DOM contains or belongs to an engraving control.
  new MutationObserver(records => {
    const engravingChanged = records.some(record =>
      Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (
          node.matches?.('[data-rx-engraving]') ||
          node.querySelector?.('[data-rx-engraving]') ||
          node.closest?.('[data-rx-engraving]')
        )
      )
    );
    if (engravingChanged && !frame) {
      frame = requestAnimationFrame(() => { frame = null; init(); });
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
